import script from "./Preview2.vue?vue&type=script&setup=true&lang=js"
export * from "./Preview2.vue?vue&type=script&setup=true&lang=js"

import "./Preview2.vue?vue&type=style&index=0&id=1d183363&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d183363"]])

export default __exports__